import React, { ReactNode } from 'react';
import { ReactComponent as Quote } from './images/quote.svg';
import DennisYu from './images/dennis-yu.png';
import Blitzmetrics from './images/blitzmetrics.png';
import partnerQuoteSrc from './images/partner-quote.png';
import funFactSrc from './images/fun-fact.png';
import styles from './ReportFooter.module.css';
import { LLRActionButtonsProps } from '../LLRActionButtons/LLRActionButtons';
import { FacebookPartnerBadge, MetaBadge } from '@mm/icons';

export const ReportFooter = ({
  renderActionButtons,
  isWhiteLabel,
}: {
  renderActionButtons: (
    restProps?: Pick<
      LLRActionButtonsProps,
      'buttonName' | 'withFBBadges' | 'css' | 'iconProps'
    >,
  ) => ReactNode;
  isWhiteLabel?: boolean;
}) => (
  <div className={styles.container}>
    <div className={styles.quoteBlock}>
      <div className={styles.quote}>
        <Quote />
        We were able to generate an unbelievable 60x increase in Return on Ad
        Spend for clients. It blew my mind…super easy to implement and results
        that used to cost $60 with pay-per-click ads cost less than a dollar
        now.
      </div>
      <div className={styles.avatarBlock}>
        <img src={DennisYu} alt="Dennis Yu" className={styles.avatar} />
        <div className={styles.column}>
          <span className={styles.avatarName}>Dennis Yu</span>
          <span>CTO and Founder, Blitz Metrics</span>
        </div>
        <img
          src={Blitzmetrics}
          alt="Bliz Metrics"
          className={styles.companyLogo}
        />
      </div>
    </div>
    <div className={styles.ctaBlock}>
      <div className={styles.titleWrapper}>
        <div className={styles.badges}>
          <MetaBadge />
          <FacebookPartnerBadge />
        </div>
        <div className={styles.text}>One line of code and 30 minutes</div>
        <div className={styles.title}>
          to <span className={styles.highlighted}>guarantee a 30% event</span>
          <br />
          match quality score
        </div>
      </div>
      <div className={styles.cta}>
        Schedule a time to meet with our certified Meta Signal Engineers
        {renderActionButtons({
          buttonName: 'Improve My Score',
          withFBBadges: false,
          iconProps: { width: 50, height: 23 },
          css: {
            primaryButton: styles.ctaButton,
            demoButton: styles.demoButton,
          },
        })}
      </div>
    </div>
    {!isWhiteLabel && (
      <div className={styles.partnersBlock}>
        <div className={styles.partnerQuote}>
          <img
            src={partnerQuoteSrc}
            alt="We are delighted to work with Customers.ai as a preferred partner"
            className={styles.image}
          />
          <span className={styles.emoji}>👏</span>
        </div>
        <div className={styles.partnerQuote}>
          <img
            src={funFactSrc}
            alt="Our Founder was the #1 spender on google ads in 2001."
            className={styles.image}
          />
          <span className={styles.emoji}>💰</span>
        </div>
      </div>
    )}
  </div>
);
